module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-box",
    class: _vm.selectorClass,
    style: ([_vm.position, _vm.styles.popover])
  }, [(_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popover-box__content",
    class: _vm.styles.content
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b4abe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/builderComponents/PopoverBox.vue
// module id = 1858
// module chunks = 0